(function () {

  'use strict';

  /* Wireless ResetVoicemailPassword Controller - START */
  eclipseApp.controller('resetVoicemailPasswordCtrl', ['$scope', '$rootScope', '$state', '$stateParams', '$sessionStorage', 'uteLocale', 'commonService', 'httpService', 'dtmService', '$translate', 'dtmServiceConstants', function ($scope, $rootScope, $state, $stateParams, $sessionStorage, uteLocale, commonService, httpService, dtmService, $translate, dtmServiceConstants) {

    console.log('Inside Reset Voicemail Password Controller');
    var dtmRule = dtmServiceConstants.dtmRules.updateVMPassword;

    $scope.$extend({

      accountDetails: commonService.accountDetails,
      selectedBAN: $stateParams.accountNumber,
      selectedCTN: $stateParams.subscriberNo,
      $storage: $sessionStorage,
      language: uteLocale.language,
      subscriberNumberList: [],
      resetVoicemailPasswordInfo: null,
      resetVoicemailPasswordInfoError: null,
      showConfirmPasswordIcon: false,
      directConfirmPWDChange: false,
      hideConfirmPasswordIcon: false,

      proceedWithChangePassword: function () {
        if (!$stateParams.accountNumber) {
          $scope.selectedBAN = $rootScope.userInfo.selectedAccountNumber;
        }
        if (!$stateParams.subscriberNo) {
          $scope.selectedCTN = $rootScope.userInfo.selectedSubscriberNo;
        }
        if ($scope.passwordResetForm.$valid && ($scope.newPassword === $scope.confirmPassword)) {
          var promise = httpService.send(
            'v1/wireless/voicemail/password/reset',
            {
              accountNumber: $scope.selectedBAN,
              ctn: $scope.selectedCTN,
              password: $scope.confirmPassword,
              language: $scope.language
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                var errorMessage = angular.isString(result.data.error) ? result.data.error || dtmRule.defaultServerError: dtmRule.defaultServerError;
                dtmService.fireDtmExceptions(dtmRule.name, [errorMessage], 'SS');
                $scope.resetVoicemailPasswordInfoError = true;
              } else {

                dtmService.complete(dtmRule.name);

                $scope.resetVoicemailPasswordInfo = result.data;
                $state.go('myAccount.resetVoicemailPasswordConfirmation', {
                  'accountNumber': $scope.selectedBAN,
                  'subscriberNo': $scope.selectedCTN,
                  'confirmedPd': $scope.confirmPassword
                });
              }
            },
            function (reason) {
              var error = reason ? reason.data : null;
              var errorMessage = angular.isString(error) ? error || dtmRule.defaultServerError: dtmRule.defaultServerError;
              dtmService.fireDtmExceptions(dtmRule.name, [errorMessage], 'SS');
              $scope.resetVoicemailPasswordInfoError = true;
            }
          );
        } else {
          if ($scope.passwordResetForm.$valid && $scope.newPassword != $scope.confirmPassword) {
            $scope.passwordResetForm.newPassword.$touched = true;
            $scope.passwordResetForm.newPassword.$setTouched()
            $scope.passwordResetForm.confirmPassword.$touched = true;
            $scope.passwordResetForm.confirmPassword.$setTouched();
            $scope.passwordResetForm.confirmPassword.$setValidity('passwordVerify', false);
          } else {
            $scope.passwordResetForm.newPassword.$touched = true;
            $scope.passwordResetForm.newPassword.$setTouched();
            $scope.passwordResetForm.confirmPassword.$touched = true;
            $scope.passwordResetForm.confirmPassword.$setTouched();
          }

          fireDtmException();
        }
      },

      passwordCheck: function () {
        if ($scope.confirmPassword && $scope.newPassword) {
          if (($scope.confirmPassword.length > $scope.newPassword.length) && $scope.confirmPassword.length == 5) {
            $scope.showConfirmPasswordIcon = true;
            $scope.hideConfirmPasswordIcon = false;
            $scope.passwordResetForm.confirmPassword.$setValidity('passwordVerify', false);
          } else if ($scope.confirmPassword.length >= $scope.newPassword.length) {
            $scope.showConfirmPasswordIcon = true;
            $scope.hideConfirmPasswordIcon = false;
          } else {
            $scope.showConfirmPasswordIcon = false;
            $scope.hideConfirmPasswordIcon = true;
            $scope.passwordResetForm.confirmPassword.$setValidity('passwordVerify', true);
          }
        } else {
          if (($scope.confirmPassword && $scope.confirmPassword.length > 0) && (!$scope.newPassword || $scope.newPassword.length == 0)
            && (!$scope.passwordResetForm.newPassword.$touched || !$scope.passwordResetForm.newPassword.$viewValue || $scope.passwordResetForm.newPassword.$viewValue.length == 0)) {
            $scope.hideConfirmPasswordIcon = false;
            $scope.passwordResetForm.confirmPassword.$setValidity('passwordVerify', true);
            $scope.passwordResetForm.confirmPassword.$setValidity('required', false);
            $scope.directConfirmPWDChange = true;
          } else {
            if (!$scope.newPassword && $scope.passwordResetForm.newPassword.$viewValue && $scope.passwordResetForm.newPassword.$viewValue.length > 0
              && $scope.confirmPassword && $scope.confirmPassword.length <= 5) {
              $scope.hideConfirmPasswordIcon = true;
            } else {
              $scope.hideConfirmPasswordIcon = false;
            }
          }
        }
      },

      makeNewPWDTouched: function (keyEvent) {
        if (!(keyEvent.which === 13)) {
          $scope.passwordResetForm.newPassword.$touched = true;
          $scope.passwordResetForm.newPassword.$setTouched();
          if ($scope.directConfirmPWDChange) {
            $scope.directConfirmPWDChange = false;
            if (!$scope.passwordResetForm.confirmPassword.$error.maxlength && !$scope.passwordResetForm.confirmPassword.$error.minlength
              && !$scope.passwordResetForm.confirmPassword.$error.pattern && !$scope.passwordResetForm.confirmPassword.$error.passwordVerify) {
              $scope.showConfirmPasswordIcon = false;
              $scope.hideConfirmPasswordIcon = true;
            }
            $scope.passwordResetForm.confirmPassword.$setValidity('required', true);
          }
        }
      },

      makeConfirmPWDTouched: function (keyEvent) {
        if (!(keyEvent.which === 13)) {
          $scope.passwordResetForm.confirmPassword.$touched = true;
          $scope.passwordResetForm.confirmPassword.$setTouched();
        }
      },

      cancel: function () {
        _.each($scope.accountDetails, function (accountDetail) {
          if ($scope.selectedBAN === accountDetail.accountNumber) {
            if (accountDetail.LOB === 'WL') {
              $state.go('myAccount.wireless', {
                'accountNumber': $scope.selectedBAN,
                'subscriberNo': $scope.selectedCTN
              });
            } else if (accountDetail.LOB === 'WLPP') {
              $state.go('myAccount.prepaidWLDashboard', {
                'accountNumber': $scope.selectedBAN,
                'subscriberNo': $scope.selectedCTN
              });
            } else {

            }
          }
        });
      }

    });

    function fireDtmException() {
      var errorKey1, errorKey2, errorKeys = [];
      if ($scope.passwordResetForm.$invalid) {
        if ($scope.passwordResetForm.newPassword.$error.required) {
          errorKey1 = 'wireless.error.enterYouNewPasswordInBothFields';
        }
        else if ($scope.passwordResetForm.newPassword.$error.pattern) {
          errorKey1 = 'wireless.error.newPasswordHasToContainNumberOnly';
        }
        else if ($scope.passwordResetForm.newPassword.$error.minlength || $scope.passwordResetForm.newPassword.$error.maxlength) {
          errorKey1 = 'wireless.error.newPasswordHasToBe4or5DigitsLong';
        }

        if ($scope.passwordResetForm.confirmPassword.$error.required) {
          errorKey2 = 'wireless.error.enterYouNewPasswordInBothFields';
        }
        else if ($scope.passwordResetForm.confirmPassword.$error.pattern) {
          errorKey2 = 'wireless.error.newPasswordHasToContainNumberOnly';
        }
        else if ($scope.passwordResetForm.confirmPassword.$error.minlength || $scope.passwordResetForm.confirmPassword.$error.maxlength) {
          errorKey2 = 'wireless.error.newPasswordHasToBe4or5DigitsLong';
        }

        if (!(errorKey1 || errorKey2) && ($scope.passwordResetForm.newPassword.$error.passwordVerify || $scope.passwordResetForm.confirmPassword.$error.passwordVerify)) {
          errorKey1 = 'wireless.error.passwordsDidNotMatch';
        }
      }

      if (errorKey1 || errorKey2) {
        if (errorKey1 !== errorKey2) {
          if (errorKey1) {
            errorKeys.push(errorKey1);
          }
          if (errorKey2) {
            errorKeys.push(errorKey2);
          }
        } else {
          errorKeys.push(errorKey1)
        }
      }

      if (errorKeys.length > 0) {
        $translate(errorKeys).then(function (translatedValues) {
          var values = [];
          angular.forEach(errorKeys, function (value) {
            values.push(translatedValues[value]);
          });

          dtmService.fireDtmExceptions(dtmRule.name, values, 'CS');
        });
      }
    }

  }]);

  /* Wireless ResetVoicemailPassword Controller - END */

})();



